/* eslint-disable
    no-param-reassign,
*/
angular.module('unergie.main')
.filter('truncate', () =>
    function (text, length, end) {
        if (_.isEmpty(text)) {
            return
        }
        if (isNaN(length)) {
            length = 10
        }
        end = end || '...'
        if ((text.length <= length) || ((text.length - (end.length)) <= length)) {
            return text
        }
        return String(text).substring(0, length - (end.length)) + end
    },
)
